import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pagination = _resolveComponent("pagination")!

  return (_ctx.pagesCount > 1)
    ? (_openBlock(), _createBlock(_component_pagination, {
        key: 0,
        name: _ctx.name,
        "show-page-buttons": _ctx.showPageButtons,
        "pages-count": _ctx.pagesCount,
        page: _ctx.currentPage,
        "placeholder-element": "products-list-pagination",
        onChange: _ctx.onPagerChange
      }, null, 8 /* PROPS */, ["name", "show-page-buttons", "pages-count", "page", "onChange"]))
    : _createCommentVNode("v-if", true)
}